import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.6.14-XM80lRoYRUdkHMpUfMaX/mode=imports,min/optimized/keen-slider.js';

const { CarouselElement } = window.BAO.Carousel;
const { setInitialised, useDots } = window.BAO.Carousel.plugins;

class ImageSwiper extends CarouselElement {
	static get requiredElements() {
		return ['slider', 'slide', 'thumbnail'];
  }

  setupListeners() {
		super.setupListeners();

    this.onLayoutUpdate = this.onLayoutUpdate.bind(this);

		if (this.externalEls?.grid) {
			this.listeners.add(this.externalEls?.grid?.element, 'grid:update', this.onLayoutUpdate)
		}

		this.carousel = KeenSlider(this.els?.slider?.element, this.options)
  }

  onLayoutUpdate() {
    setTimeout(() => {
			this.carousel.update();
    }, 16);
  }

  get options() {
    return {
			selector: '.keen-slider__slide',
      slides: {
        perView: 1,
        spacing: 0,
      },
    };
  }

  get plugins() {
    return [setInitialised(), useDots(this.els?.thumbnail?.elements)];
  }
}

const viewportWidth =
  window.innerWidth ||
  document.documentElement.clientWidth ||
  document.body.clientWidth;

if (!customElements.get('image-swiper') && viewportWidth <= 768) {
  customElements.define('image-swiper', ImageSwiper);
} else if (viewportWidth > 768) {
  document.querySelectorAll('[data-image-swiper-el]').forEach((slider) => {
    slider.classList.remove('keen-slider');
    slider.classList.remove('keen-slider__slide');
  });
}
